import React, { createContext, useContext, useState, useEffect } from 'react';
import {
  getLanguage,
  setLanguage as setI18nLanguage,
  loadLanguageFromBackend,
  translate as i18nTranslate,
} from './i18n';
import { getToken } from './auth';

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [language, setLanguageState] = useState(getLanguage);

  useEffect(() => {
    if (!getToken()) return;
    const load = async () => {
      await loadLanguageFromBackend();
      setLanguageState(getLanguage());
    };
    load();
  }, []);

  const setLanguage = async (lang, saveToBackend = true) => {
    await setI18nLanguage(lang, saveToBackend);
    setLanguageState(getLanguage());
  };

  const translate = (key) => i18nTranslate(key);

  const value = { language, setLanguage, translate };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useTranslation = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) {
    throw new Error('useTranslation must be used within LanguageProvider');
  }
  return ctx;
};
